import styled from "styled-components";

interface IButton {
  name?: string;
  onClick?: () => void;
  icon?: any;
}

export default function CancelButton({
  name,
  onClick,
  icon
}: IButton) {
  return (
    <Container type='button' onClick={onClick}>
      {name && <p>{name}</p>}
      {icon}
    </Container>
  );
}

const Container = styled.button`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.gray.gray_800};
  color: ${(props) => props.theme.colors.gray.gray_800};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 30px;
  padding: 8px 14px;

  font-weight: 500;
  font-size: 16px;
  
  white-space: nowrap;
  text-align: center; 

  &:hover {
    color: ${(props) => props.theme.colors.gray.gray_200};
  }
`;
